import { t } from 'typegate';
export var DateTimeReference;
(function (DateTimeReference) {
    DateTimeReference["currentDateTime"] = "current_date_time";
})(DateTimeReference || (DateTimeReference = {}));
export const AgeRoundingTypes = {
    lastBirthday: 'lastBirthday', // Being 30.1 years old = rounded to 30
    nextBirthday: 'nextBirthday', // Being 30.1 years old = rounded to 31
    closestBirthday: 'closestBirthday', // Being 30.1 years old = rounded to 30
    none: 'none',
};
export var AgeFactor;
(function (AgeFactor) {
    AgeFactor["minor"] = "minor";
})(AgeFactor || (AgeFactor = {}));
export const TimeUnitRoundingTypes = {
    none: 'none', // Count from 0, you are 0 days old at birth
    nextUnit: 'nextUnit', // Count from 1, you are 1 day old at birth
};
export const timeRoudingType = t.union(t.enum(AgeRoundingTypes), t.enum(TimeUnitRoundingTypes));
export const DateUnits = {
    day: 'day',
    week: 'week',
    month: 'month',
    year: 'year',
    hour: 'hour',
    minute: 'minute',
    second: 'second',
    millisecond: 'millisecond',
};
export const ShiftMagnitudes = {
    earliestDateRespectingShiftValue: 'earliestDateRespectingShiftValue',
    latestDateRespectingShiftValue: 'latestDateRespectingShiftValue',
};
